export const ADD_BILL_START = 'ADD_BILL_START';
export const ADD_BILL_SUCCESS = 'ADD_BILL_SUCCESS';
export const ADD_BILL_ERROR = 'ADD_BILL_ERROR';
